export const platformSettingsZh = {
  breadcrumb: {
    root: '平台设置',
    active: '通用配置',
  },
  header: {
    title: '平台设置',
    subtitle: '统一管理验证码频次、余额提醒与月度账单配置',
    configCount: '3 项配置',
  },
  toggle: {
    enabled: '已开启',
    disabled: '已关闭',
  },
  codeFrequency: {
    title: '验证码频次设置',
    subtitle: '限制验证码短信的发送频率，防止恶意刷量',
    intervalLabel: '同号码间隔时间',
    intervalPlaceholder: '输入间隔分钟数',
    intervalSuffix: '分钟',
    intervalHint: '同一号码在此时间内不可重复请求验证码',
    dailyLimitLabel: '同号码每日上限',
    dailyLimitPlaceholder: '输入每日上限次数',
    dailyLimitSuffix: '次/天',
    dailyLimitHint: '同一号码每天最多可请求验证码的次数',
    alertEmailLabel: '预警邮箱',
    alertEmailPlaceholder: '请输入接收预警通知的邮箱',
    alertEmailHint: '当请求超出频率限制时，系统将发送预警邮件至此邮箱',
  },
  balanceAlert: {
    title: '余额提醒设置',
    subtitle: '当账户余额低于阈值时，自动发送提醒通知',
    thresholdLabel: '余额阈值',
    thresholdPlaceholder: '输入金额',
    thresholdHint: '当账户余额低于此金额时，系统将自动发送提醒邮件',
    frequencyLabel: '提醒频率',
    emailLabel: '提醒邮箱',
    emailPlaceholder: '请输入接收提醒的邮箱地址',
    frequency: {
      daily: '每天',
      weekly: '每周',
      monthly: '每月',
    },
  },
  monthlyBill: {
    title: '月度账单设置',
    subtitle: '每月自动生成账单并发送至指定邮箱',
    emailLabel: '账单邮箱',
    emailPlaceholder: '请输入接收账单的邮箱地址',
    billDayLabel: '账单日',
    billDayValue: '每月 {n} 日',
    billDayHint: '每月该日期自动生成上月账单，可选 1-28 日',
    formatLabel: '账单格式',
    formatExcel: 'Excel',
  },
  saveBar: {
    hint: '修改设置后请点击保存，设置将即时生效',
    saving: '保存中...',
    saved: '已保存',
    saveAll: '保存全部设置',
  },
  messages: {
    saveSuccess: '设置已保存',
    saveFailed: '保存失败',
  },
}

export const platformSettingsEn = {
  breadcrumb: {
    root: 'Settings',
    active: 'General',
  },
  header: {
    title: 'Platform Settings',
    subtitle: 'Manage OTP rate limits, balance alerts, and monthly billing',
    configCount: '3 settings',
  },
  toggle: {
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
  codeFrequency: {
    title: 'OTP Rate Limits',
    subtitle: 'Limit OTP SMS frequency to prevent abuse',
    intervalLabel: 'Interval per Number',
    intervalPlaceholder: 'Enter interval in minutes',
    intervalSuffix: 'min',
    intervalHint: 'The same number cannot request an OTP again within this interval',
    dailyLimitLabel: 'Daily Limit per Number',
    dailyLimitPlaceholder: 'Enter daily limit',
    dailyLimitSuffix: '/day',
    dailyLimitHint: 'Maximum OTP requests per number per day',
    alertEmailLabel: 'Alert Email',
    alertEmailPlaceholder: 'Enter email for rate-limit alerts',
    alertEmailHint: 'Alerts are sent to this email when rate limits are exceeded',
  },
  balanceAlert: {
    title: 'Balance Alerts',
    subtitle: 'Send notifications when account balance falls below threshold',
    thresholdLabel: 'Balance Threshold',
    thresholdPlaceholder: 'Enter amount',
    thresholdHint: 'An alert email is sent when balance falls below this amount',
    frequencyLabel: 'Alert Frequency',
    emailLabel: 'Alert Email',
    emailPlaceholder: 'Enter email for balance alerts',
    frequency: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
    },
  },
  monthlyBill: {
    title: 'Monthly Billing',
    subtitle: 'Automatically generate and email monthly statements',
    emailLabel: 'Billing Email',
    emailPlaceholder: 'Enter email for monthly statements',
    billDayLabel: 'Billing Day',
    billDayValue: 'Day {n} of each month',
    billDayHint: 'Previous month\'s statement is generated on this day (1–28)',
    formatLabel: 'Statement Format',
    formatExcel: 'Excel',
  },
  saveBar: {
    hint: 'Click Save after making changes. Settings take effect immediately.',
    saving: 'Saving...',
    saved: 'Saved',
    saveAll: 'Save All Settings',
  },
  messages: {
    saveSuccess: 'Settings saved',
    saveFailed: 'Save failed',
  },
}

export const platformSettingsJa = {
  breadcrumb: {
    root: '設定',
    active: '一般設定',
  },
  header: {
    title: 'プラットフォーム設定',
    subtitle: 'OTP頻度制限、残高通知、月次請求の一元管理',
    configCount: '3 項目',
  },
  toggle: {
    enabled: '有効',
    disabled: '無効',
  },
  codeFrequency: {
    title: 'OTP頻度設定',
    subtitle: 'OTP SMSの送信頻度を制限し、不正利用を防止',
    intervalLabel: '同一番号の間隔',
    intervalPlaceholder: '間隔（分）を入力',
    intervalSuffix: '分',
    intervalHint: '同一番号はこの時間内にOTPを再リクエストできません',
    dailyLimitLabel: '同一番号の日次上限',
    dailyLimitPlaceholder: '日次上限回数を入力',
    dailyLimitSuffix: '回/日',
    dailyLimitHint: '同一番号が1日にリクエストできるOTPの最大回数',
    alertEmailLabel: '警告メール',
    alertEmailPlaceholder: '警告通知を受け取るメールアドレス',
    alertEmailHint: '頻度制限を超えた場合、このメールアドレスに警告を送信',
  },
  balanceAlert: {
    title: '残高通知設定',
    subtitle: '残高が閾値を下回った際に自動通知',
    thresholdLabel: '残高閾値',
    thresholdPlaceholder: '金額を入力',
    thresholdHint: '残高がこの金額を下回ると通知メールを送信',
    frequencyLabel: '通知頻度',
    emailLabel: '通知メール',
    emailPlaceholder: '通知を受け取るメールアドレス',
    frequency: {
      daily: '毎日',
      weekly: '毎週',
      monthly: '毎月',
    },
  },
  monthlyBill: {
    title: '月次請求設定',
    subtitle: '毎月自動で請求書を生成し、指定メールに送信',
    emailLabel: '請求書メール',
    emailPlaceholder: '請求書を受け取るメールアドレス',
    billDayLabel: '請求日',
    billDayValue: '毎月 {n} 日',
    billDayHint: 'この日に前月の請求書を自動生成（1〜28日から選択）',
    formatLabel: '請求書形式',
    formatExcel: 'Excel',
  },
  saveBar: {
    hint: '変更後は保存をクリックしてください。設定は即時反映されます。',
    saving: '保存中...',
    saved: '保存済み',
    saveAll: 'すべての設定を保存',
  },
  messages: {
    saveSuccess: '設定を保存しました',
    saveFailed: '保存に失敗しました',
  },
}
